import React from 'react'
import BaseIcon from 'react-icon-base'

const KR = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>KR</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <filter id="b" width="104.8%" height="106.7%" x="-2.4%" y="-3.3%" filterUnits="objectBoundingBox">
        <feMorphology in="SourceAlpha" radius="1" result="shadowSpreadInner1" />
        <feOffset in="shadowSpreadInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121659873 0" />
      </filter>
      <rect id="d" width="20" height="14" x=".5" y=".5" rx="1" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="c" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#FFF" xlinkHref="#a" />
      <use fill="#000" filter="url(#b)" xlinkHref="#a" />
      <path
        fill="#0048AB"
        d="M14 7.5a3.5 3.5 0 0 1-7 0c0-1.12 2.35-1.591 4.328-1.413.21-.056.436-.087.672-.087 1.105 0 2 .672 2 1.5z"
        mask="url(#c)"
      />
      <path
        fill="#CD0027"
        d="M9.618 7.5H10c0-.828.895-1.5 2-1.5s2 .672 2 1.5a3.5 3.5 0 0 0-6.664-1.498C7.131 6.075 7 6.223 7 6.5c0 .136.018.268.052.394-.034.197-.052.4-.052.606h.382a1.496 1.496 0 0 0 2.236 0z"
        mask="url(#c)"
      />
      <path
        fill="#252526"
        d="M15 5h2l-2-2h-1l1 2zM6 5H4l2-2h1L6 5zm9 5h2l-2 2h-1l1-2zm-9 0H4l2 2h1l-1-2z"
        mask="url(#c)"
      />
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#d" />
    </g>
  </BaseIcon>
)

export default KR
